import { apiClient } from '@/lib/api/client';
export const servicesApi = {
    async list(groupId) {
        const { data } = await apiClient.get(`/api/v1/groups/${groupId}/services`);
        return data;
    },
    async create(groupId, dto) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/services`, dto);
        return data;
    },
    async update(groupId, id, dto) {
        const { data } = await apiClient.patch(`/api/v1/groups/${groupId}/services/${id}`, dto);
        return data;
    },
    async delete(groupId, id) {
        await apiClient.delete(`/api/v1/groups/${groupId}/services/${id}`);
    },
    async cloneBatch(groupId, dto) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/services/clone-batch`, dto);
        return data;
    },
    async bulkUpdateStatus(groupId, dto) {
        const { data } = await apiClient.patch(`/api/v1/groups/${groupId}/services/status`, dto);
        return data;
    },
};
//# sourceMappingURL=services.js.map